
let language = {
    CREATE_FOLDER_TITLE: "创建新文件夹",
    CREATE_FOLDER_NEW_FOLDER_LABEL: "新建文件夹",
    CREATE_FOLDER_FOLDER_NAME_PLACEHOLDER: "请输入文件夹名称",
    
    
    CREATE_FOLDER_CANCEL_BTN: "取消",
    CREATE_FOLDER_CREATE_BTN: "创建",
    
    // 
    CREATE_FOLDER_PATTERN_ERROR_TIPS: "文件名不能包含以下符号: \\ \/ \: \* \? \" \< \> \|",
};

export { language }